/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { MapTo } from '@adobe/aem-react-editable-components';
import { ResponsiveGrid } from './ResponsiveGrid';

type ComponentType = React.ComponentType<any>;

const DEFAULT_MAPPING = {
  'wcm/foundation/components/responsivegrid': ResponsiveGrid,
  'mi-aem-common-spa/components/container': ResponsiveGrid,
};

let isRegistered = false;

export const registerAemComponents = (customMapping: Record<string, ComponentType> = {}) => {
  if (isRegistered) {
    return;
  }

  const STORYBOOK_AEM_MAPPING = {
    ...DEFAULT_MAPPING,
    ...customMapping,
  };
  try {
    Object.entries(STORYBOOK_AEM_MAPPING).forEach(([resourceType, component]) => {
      try {
        if (component) {
          console.log(
            `[Storybook] Registering AEM component: ${resourceType} -> ${component?.name || 'AnonymousComponent'}`
          );
          MapTo(resourceType)(component);
        }
      } catch (e) {
        console.warn(`⚠️ [Storybook] Failed to MapTo ${resourceType}`, e);
      }
    });
    isRegistered = true;
    console.info('[Storybook] Registering AEM components completed successfully ✅');
  } catch (error) {
    console.error('[Storybook] Failed to register AEM components:', error);
  }
};
